import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22 3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2.41a1 1 0 0 0 .287.7l6.426 6.544a1 1 0 0 1 .287.7v7.952a.5.5 0 0 0 .658.475l5-1.667A.5.5 0 0 0 15 19.64v-6.286a1 1 0 0 1 .287-.7l6.426-6.544a1 1 0 0 0 .287-.7z"
    }, null, -1)
  ])))
}
export default { render: render }